@if (isSubmitted === false) {
  <div class="buttons">
    <button
      class="submit primary-action-btn"
      (click)="submitClicked.emit()"
      [disabled]="!enableSubmitButton"
      >
      Submit
    </button>
  </div>
}
@if (isSubmitted === true) {
  <app-upload-confirmation></app-upload-confirmation>
}
